import { render, staticRenderFns } from "./PracticalTrainOperate.vue?vue&type=template&id=01c9b233&scoped=true"
import script from "./PracticalTrainOperate.vue?vue&type=script&lang=js"
export * from "./PracticalTrainOperate.vue?vue&type=script&lang=js"
import style0 from "./PracticalTrainOperate.vue?vue&type=style&index=0&id=01c9b233&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c9b233",
  null
  
)

export default component.exports